import jwt_decode from 'jwt-decode'
export const state = () => ({
  countdownOff: false,
  doctorData: null,
  userData: null,
  confirmation: null,
  isLoggedIn: false,
  stepComponent: 'initial',
  selectedPayment: null,
  selectedPaymentIndex: null,
  appointmentBook: null,
  tempToken: null,
  balance: 0,
  booking: {
    bookingFailed: false,
    selectedAppointment: null,
    payment: null,
    va: {
      ExpiredAt: null
    },
    bookingFinished: false,
    midtrans: null
  },
  canUsePromo: true,
  scrollTop: 0,
  percentageDoctorFee: null,
  promo: {
    list: [],
    used: null
  },
  useYesdokBalance: null
})

export const mutations = {
  SET_TEMPORARY_TOKEN: (state, data) => {
    state.tempToken = data
  },
  SET_COUNTDOWN_OFF: (state, data) => {
    state.countdownOff = data
  },
  SET_PAYMENT: (state, data) => {
    state.selectedPayment = data
  },
  SET_APPOINTMENT_BOOK: (state, data) => {
    state.appointmentBook = data
  },
  SET_PAYMENT_INDEX: (state, data) => {
    state.selectedPaymentIndex = data
  },
  SET_BALANCE: (state, data) => {
    state.balance = data
  },
  SET_CAN_USE_PROMO: (state, data) => {
    state.canUsePromo = data
  },
  SET_DOCTOR_DATA: (state, data) => {
    state.doctorData = data
  },
  SET_BOOKING_FAILED: (state, data) => {
    state.booking.bookingFailed = data
  },
  SET_BOOKING_APPOINTMENT: (state, data) => {
    state.booking.selectedAppointment = data
  },
  SET_STEP: (state, data) => {
    state.stepComponent = data
  },
  SET_USER_IS_LOGGED: (state, data) => {
    state.isLoggedIn = data
  },
  SET_USER_DATA: (state, data) => {
    state.userData = data
  },
  SET_USER_CONFIRMATION_OTP: (state, data) => {
    state.confirmation = data
  },
  SET_BOOKING_PAYMENT: (state, data) => {
    state.booking.payment = data
  },
  SET_VA_DATA: (state, data) => {
    state.booking.va = data
  },
  SET_BOOKING_FINISHED: (state, data) => {
    state.booking.bookingFinished = data
  },
  SET_SCROLL_TOP: (state, data) => {
    state.scrollTop = data
  },
  SET_PERCENTAGE_DOCTOR_FEE: (state, data) => {
    state.percentageDoctorFee = data
  },
  SET_MIDTRANS_DATA: (state, data) => {
    state.booking.midtrans = data
  },
  SET_PROMO_LIST: (state, data) => {
    state.promo.list = data
  },
  SET_PROMO_USED: (state, data) => {
    state.promo.used = data
  },
  SET_USE_YESDOK_BALANCE: (state, data) => {
    state.useYesdokBalance = data
  }
}

export const actions = {
  nearest ({ commit }, data) {
    const { did } = data

    return new Promise((resolve, reject) => {
      this.$api.get('calendars/appointment/' + did + '/nearest')
        .then(function (response) {
          const res = response.data.Data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  check ({ commit, rootState }, data) {
    const { did, clinicName, timestampStart, timestampEnd } = data

    let params = ''
    if (clinicName) {
      params += `?PublicID=${clinicName}`
    }
    const token = rootState.patient.auth.token || null

    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API + `calendars/appointments/${did}/${timestampStart}/${timestampEnd}${params}`, {
        headers: {
          DeviceType: 'web',
          Authorization: token ? `Bearer ${token}` : null
        }
      })
        .then(function (response) {
          const res = response.data

          if (response.status === 200) {
            if (res.Data && res.Data.Doctor) {
              commit('SET_DOCTOR_DATA', res.Data)
            }
            commit('SET_CAN_USE_PROMO', res.Data.CanUsePromo)
          }
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  submitLogin ({ commit }, data) {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API_V4 + `patient/sign/in?Email=${data}`, {
        headers: {
          WebVersion: '1'
        }
      })
        .then(function (response) {
          const data = response.data
          const decoded = jwt_decode(`${data.Data.AccessToken}`)
          commit('SET_USER_DATA', decoded)
          commit('SET_TEMPORARY_TOKEN', data.Data.AccessToken)
          localStorage.setItem('user_data', JSON.stringify(decoded))
          resolve(data)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },
  resendOtp ({ commit }, token) {
    return new Promise((resolve, reject) => {
      this.$axios.post(process.env.BASE_API + 'phone/resend', null, {
        headers: {
          WebVersion: '3',
          Authorization: 'Bearer ' + token
        }
      })
        .then(function (response) {
          const data = response.data

          commit('SET_USER_DATA', data.Data)
          localStorage.setItem('user_data', JSON.stringify(data.Data))
          resolve(data)
        })
        .catch(function (error) {
          reject(error.response)
        })
    })
  },
  resendOtpV4 ({ commit, rootState }, data) {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API_V4 + 'patient/otp/auth/resend', {
        headers: {
          WebVersion: '3',
          Authorization: 'Bearer ' + rootState.doctor.tempToken
        }
      })
        .then(function (response) {
          const data = response.data
          if (data.Data) {
            commit('SET_USER_DATA', data.Data)
            localStorage.setItem('user_data', JSON.stringify(data.Data))
          }
          resolve(response)
        })
        .catch(function (error) {
          reject(error.response)
        })
    })
  },
  verification ({ commit, rootState }, data) {
    return new Promise((resolve, reject) => {
      this.$axios.post(process.env.BASE_API_V4 + 'patient/otp/auth/verify', data, {
        headers: {
          WebVersion: '1',
          Authorization: 'Bearer ' + rootState.doctor.tempToken
        }
      })
        .then(function (response) {
          const data = response.data
          if (data.Data) {
            commit('SET_USER_CONFIRMATION_OTP', data.Data)
            localStorage.setItem('token', data.Data.Token)
          }
          resolve(data)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  virtualAccountPayment ({ commit }, data) {
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API + 'appointment/transaction/' + data.id + '/va', {
        headers: {
          WebVersion: '1',
          Authorization: 'Bearer ' + data.token
        }
      })
        .then(function (response) {
          const res = response.data.Data
          commit('SET_VA_DATA', res)
          resolve(res)
        })
        .catch(function (error) {
          const err = error.response.data
          reject(err)
        })
    })
  },
  bookingPayment ({ commit, rootState, state }, data) {
    const { PaymentType, PaymentID, ID, YesDokBalance, PatientID, PaymentConsultation } = data

    let formDataPayment = {
      PaymentType,
      YesDokBalance,
      PaymentConsultation,
      PatientID
    }

    if (PaymentID) {
      formDataPayment = Object.assign(formDataPayment, { PaymentID })
    }

    const isUsePromo = !!(state.promo.used)
    if (isUsePromo) {
      const formPromoAdditional = {
        PromoID: state.promo.used.ID,
        DoctorID: state.doctorData.Doctor.ID,
        DoctorType: state.doctorData.Doctor.DoctorType
      }
      formDataPayment = Object.assign(formDataPayment, { ...formPromoAdditional })
    }

    const partner = sessionStorage.getItem('partner')
    if (partner) {
      formDataPayment = Object.assign(formDataPayment, { FromPartners: partner })
    }
    return new Promise((resolve, reject) => {
      this.$axios.post(process.env.BASE_API + 'calendar/appointment/booking/' + ID + '/payment', formDataPayment, {
        headers: {
          WebVersion: '1',
          Authorization: 'Bearer ' + rootState.patient.auth.token
        }
      }).then(function (response) {
        const res = response.data.Data
        commit('SET_BOOKING_PAYMENT', res)
        resolve(res)
      }).catch(function (error) {
        const err = error.response ? error.response.data : error
        reject(err)
      })
    })
  },

  getPercentageDoctorFee ({ rootState, state, commit }) {
    return new Promise((resolve, reject) => {
      if (state.percentageDoctorFee) {
        resolve(state.percentageDoctorFee)
      } else {
        this.$axios.get(process.env.BASE_API + rootState.user.auth.role_endpoint + 'setting/fee', {
          headers: {
            WebVersion: '1',
            DeviceType: 'web',
            Authorization: 'Bearer ' + rootState.user.auth.token
          }
        }).then(function (response) {
          const res = response.data.Data
          commit('SET_PERCENTAGE_DOCTOR_FEE', res)
          resolve(res)
        }).catch(function (error) {
          const err = error.response ? error.response.data : error
          reject(err)
        })
      }
    })
  },

  midtransPayment ({ rootState, commit }, data) {
    return new Promise((resolve, reject) => {
      this.$axios.post(process.env.BASE_API_V4 + 'patient/midtrans/pay', data, {
        headers: {
          WebVersion: '1',
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.patient.auth.token
        }
      }).then(function (response) {
        const res = response.data.Data
        commit('SET_MIDTRANS_DATA', res)
        resolve(res)
      }).catch(function (error) {
        const err = error.response.data
        reject(err)
      })
    })
  },
  fetchListPromo ({ rootState, state }, payload) {
    const { filter, paymentMethod, IsUsedYesdokBalance } = payload
    const params = {
      PromoType: 'SPECIALIST',
      Filter: filter,
      DoctorID: state.doctorData.Doctor.ID,
      DoctorType: state.doctorData.Doctor.DoctorType,
      ConsultPrice: state.booking.selectedAppointment.Price,
      PaymentMethod: paymentMethod,
      IsUsedYesdokBalance
    }
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API_V4 + 'patient/promo/list', {
        headers: {
          WebVersion: 2,
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.patient.auth.token
        },
        params
      }).then((res) => {
        resolve(res.data.Data)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  claimPromo ({ rootState }, PromoID) {
    return new Promise((resolve, reject) => {
      this.$axios.post(process.env.BASE_API_V4 + 'patient/promo/claim/' + PromoID, null, {
        headers: {
          WebVersion: 2,
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.patient.auth.token
        }
      }).then((res) => {
        resolve(res.data.Data)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  validatePromo ({ rootState, state }, payload) {
    const finalPayload = {
      ...payload,
      ConsultPrice: state.booking.selectedAppointment.Price,
      DoctorType: state.doctorData.Doctor.DoctorType,
      DoctorID: state.doctorData.Doctor.ID
    }
    return new Promise((resolve, reject) => {
      this.$axios.post(process.env.BASE_API_V4 + 'patient/promo/validate', finalPayload, {
        headers: {
          WebVersion: 2,
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.patient.auth.token
        }
      }).then((res) => {
        resolve(res.data.Data)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}
